<div class="flex items-center">
  <button (click)="onPrev()" [disabled]="isPrevDisabled()" id="catalog_result-list_btn_prev-page" mat-icon-button>
    <mat-icon>chevron_left</mat-icon>
  </button>

  <mat-slider
    (mouseup)="sliderMouseButtonReleased()"
    [disabled]="pageCount === 1"
    [max]="pageCount"
    class="w-full hidden md:block primary-slider"
    id="catalog_result-list_slr_paginator"
    min="1"
  >
    <input (dragEnd)="sliderSliding($event)" (valueChange)="sliderChanged()" [ngModel]="pageNum + 1" matSliderThumb/>
  </mat-slider>

  <button (click)="onNext()" [disabled]="isNextDisabled()" id="catalog_result-list_btn_next-page" mat-icon-button>
    <mat-icon>chevron_right</mat-icon>
  </button>
</div>
